import cx from 'classnames'
import type React from 'react'

import { ACTIONS_TOOLBAR_GAP } from './constants'
import css from './styles.module.css'

interface Props extends React.PropsWithChildren {
  // Width of the owner's border: `bottom` counts from its padding box, so the
  // border has to be added back for the gap to be measured from the outer edge.
  borderWidth?: number
  // The toolbar is out of sight but stays mounted: a popover of its own that
  // replaces it on screen, e.g. the wireframes one, keeps working.
  hidden?: boolean
  scale: number
}

// Owners select on mousedown/mouseup and their menus render through a portal
// whose events React still bubbles here, so nothing from the toolbar reaches them.
const stopPropagation = (e: React.SyntheticEvent) => {
  e.stopPropagation()
}

// Centres an actions toolbar above its owner, ACTIONS_TOOLBAR_GAP screen pixels
// from the owner's top edge at any canvas zoom. Scaling about the bottom edge
// keeps the gap exact whatever the toolbar's height.
export const ToolbarAnchor: React.FC<Props> = ({
  borderWidth = 0,
  children,
  hidden = false,
  scale,
}) => {
  const style = {
    bottom: `calc(100% + ${(ACTIONS_TOOLBAR_GAP + borderWidth) / scale}px)`,
    transform: `translateX(-50%) scale(${1 / scale})`,
    transformOrigin: 'bottom center',
  }

  return (
    <div
      className={cx(css.anchor, { [css.hidden]: hidden })}
      style={style}
      onMouseDown={stopPropagation}
      onMouseUp={stopPropagation}
      onClick={stopPropagation}
    >
      {children}
    </div>
  )
}
